<template>
  <div class="border_bottom">
    <div class="header mb-6">
      <vs-button
        color="dark"
        type="flat"
        icon-pack="feather"
        icon="icon-arrow-left"
        class="p-0"
        @click="goBack()"
      ></vs-button>
      <div class="w-full justify-right">
        <h2 class="pl-2">{{ editRoute ? $t('labels.edit_question') : $t('labels.add_question') }}</h2>
      </div>
    </div>
    <vx-card class="page-bg-color addedit-question">
      <form @submit.prevent="checkValidation()" autocomplete="off">
        <vs-row class="flex w-full vx-row mx-auto">
          <div class="vx-col sm: w-full md:w-full lg:w-1/1 d-theme-dark-bg p-0">
            <!-- Question -->
            <div class="vx-row w-full m-0">
              <div class="vx-col w-full p-0">
                <label>{{ $t('labels.question_name')}}</label>
                <vs-textarea
                  type="text"
                  class="w-full mb-0 mt-1"
                  name="question_name"
                  maxlength="250"
                  v-model="question_name"
                  icon-no-border
                  v-validate="'required'"
                  height="150"
                />
                <span class="text-danger text-sm">{{ errors.first('question_name') }}</span>
              </div>
            </div>
            <!-- Section,subsection,question -->
            <div class="vx-row w-full m-0 mt-6">
              <div class="vx-col sm: w-full md:w-1/2 p-0 md:pr-4">
                <label>{{ $t('labels.section')}}</label>
                <v-select
                  v-model="section"
                  :options="sections"
                  name="section"
                  :reduce="sections => sections.id"
                  label="name"
                  v-validate="'required'"
                  class="sec_drop mt-1"
                />
                <span class="text-danger text-sm">{{ errors.first('section') }}</span>
              </div>
              <div class="vx-col sm: w-full md:w-1/2 sm: pl-0 md:pl-4 pr-0 sm: mt-6 md:mt-0">
                <label>{{ $t('labels.sub_section')}}</label>
                <v-select
                  name="sub_section"
                  v-model="child_id"
                  :options="childSection"
                  :reduce="childSection => childSection.id"
                  label="name"
                  class="sec_drop mt-1"
                />
                <span class="text-danger text-sm">{{ errors.first('sub_section') }}</span>
              </div>
            </div>
            <div class="vx-row mt-6 m-0">
              <div class="vx-col sm: w-full md:w-1/2 pl-0 sm: pr-0 md:pr-4">
                <label>{{ $t('labels.question_number')}}</label>
                <vs-input
                  type="text"
                  class="w-full bold-fields mt-1"
                  name="number"
                  maxlength="250"
                  v-model="number"
                  icon-no-border
                  v-validate="'required'"
                />
                <span class="text-danger text-sm">{{ errors.first('number') }}</span>
              </div>
              <!-- Importance -->
              <div class="vx-col sm: w-full md:w-1/2 sm: pl-0 md:pl-4 sm: mt-6 md:mt-0">
                <label>{{ $t('labels.importance')}}</label>
                <ul class="centerx flex mt-1">
                  <li class="mr-3">
                    <vs-radio v-model="importance" vs-value="H">{{ $t('labels.high') }}</vs-radio>
                  </li>
                  <li class="mr-4">
                    <vs-radio v-model="importance" vs-value="M">{{ $t('labels.medium') }}</vs-radio>
                  </li>
                  <li class="mr-4">
                    <vs-radio v-model="importance" vs-value="L">{{ $t('labels.low') }}</vs-radio>
                  </li>
                </ul>
              </div>
            </div>
            <!-- Guidance Images -->
            <div class="vx-row w-full mx-0 mt-6 mb-6">
              <div class="vx-col sm: w-full md:w-1/2 pl-0 type pr-4">
                <label>{{ $t('labels.guidance_images')}}</label>
                <vue-upload-multiple-image
                  :popupText="$t('labels.guidance_images')"
                  :dragText="$t('labels.browse_images')"
                  primaryText
                  browseText
                  ref="multiple_image_"
                  :idUpload="'image-upload'"
                  markIsPrimaryText
                  accept="image/jpeg, image/png, image/jpg"
                  @upload-success="uploadImageSuccess"
                  @before-remove="beforeRemove"
                  @data-change="dataChange"
                  :data-images="images"
                  :maxImage="5"
                  v-if="this.receipt_images.length <= 5"
                  class="w-full mb-2 mt-1 guidance-image"
                  v-model="images"
                  name="image_upload"
                ></vue-upload-multiple-image>
              </div>
              <div class="vx-col sm: w-full md:w-1/2 sm: mt-6 md:mt-0 sm: pl-0 md:pl-4 pr-0">
                <!-- Activation Deactivation -->
                <label>{{ $t('labels.active_deactive')}}</label>
                <div class="vx-row w-full mx-0">
                  <div class="vx-col sm: w-full sm: pl-0">
                    <label class="font">{{ $t('labels.status')}}</label>
                    <vs-switch v-model="is_active" class="w-1/1">
                      <span slot="on">Active</span>
                      <span slot="off">Deactive</span>
                    </vs-switch>
                  </div>
                  <div class="vx-col sm: w-full md:w-1/2 pr-0 sm: pl-0 mt-3">
                    <label class="font flex items-baseline">{{ $t('labels.active_from') }}
                      <i :title="$t('labels.date_placeholder')" class="vs-icon notranslate icon-scale vs-button--icon feather icon-info null ml-2 text-primary"></i>
                    </label>
                    <flat-pickr
                      :config="configFromdateTimePicker"
                      inputmode="true"
                      v-model="fromDate"
                      name="active_date"
                      label="name"
                      class="mt-1"
                      placeholder="Select Date"
                      @on-change="onFromChange"
                    />
                  </div>
                  <div class="vx-col sm: w-full md:w-1/2 pr-0 sm: pl-0 md:pl-4 0 mt-3">
                    <label class="font flex items-baseline">{{ $t('labels.active_to') }}
                      <i :title="$t('labels.date_placeholder')" class="vs-icon notranslate icon-scale vs-button--icon feather icon-info null ml-2 text-primary"></i>
                    </label>
                    <flat-pickr
                      :config="configTodateTimePicker"
                      v-model="toDate"
                      name="deactive_date"
                      inputmode="true"
                      label="name"
                      class="mt-1"
                      placeholder="Select Date"
                      @on-change="onToChange"
                    />
                  </div>
                </div>
              </div>
            </div>

            <!-- Tabs -->
            <div class="mt-6 mb-4">
              <label>{{ $t('labels.other_fields')}}</label>
              <vs-tabs v-model="tab" class="question-tabs">
                <vs-tab :label="$t('labels.guidances')" class="questions">
                  <!-- Vessel Types -->
                  <div class="vx-row">
                    <div class="vx-col w-full px-4">
                      <label>{{ $t('labels.vessel_types')}}</label>
                      <ul class="centerx flex mt-4">
                        <li class="mr-4">
                          <vs-radio v-model="alltype" vs-value="A">{{ $t('labels.all') }}</vs-radio>
                        </li>

                        <li class="mr-4 ml-3">
                          <vs-radio
                            v-model="alltype"
                            vs-value="ST"
                          >{{ $t('labels.specific_to_type') }}</vs-radio>
                        </li>
                      </ul>
                    </div>
                    <div class="vx-col w-full px-4 mt-3" v-if="alltype === 'ST'">
                      <v-select
                        multiple
                        v-model="type"
                        name="vesselType"
                        :options="vesselTypes"
                        :reduce="vesselTypes => vesselTypes"
                        label="name"
                        v-validate="'required'"
                        :closeOnSelect="false"
                      />
                      <span class="text-danger text-sm">{{ errors.first('vesselType') }}</span>
                    </div>
                  </div>
                  <!-- Guidance for specific types -->
                  <div class="vx-row w-full mx-0 mt-6" v-if="alltype === 'A'">
                    <div class="vx-col sm: w-full pl-0 type pr-0">
                      <label>{{ $t('labels.guidance_box')}}</label>
                      <vs-textarea
                        type="text"
                        class="w-full mb-0"
                        name="vessel_guidance"
                        maxlength="5000"
                        v-model="vessel_type_guidance"
                        icon-no-border
                        v-validate="'required'"
                        height="150"
                      />
                      <span class="text-danger text-sm">{{ errors.first('vessel_guidance') }}</span>
                    </div>
                  </div>
                  <div v-if="alltype === 'ST'">
                    <div
                      class="vx-row w-full mx-0 mt-6"
                      v-for="(specific_vessel_type_guidance, index) in vessel_type_guidance_array"
                      :key="index"
                    >
                      <div class="vx-col sm: w-full pl-0 type pr-0">
                        <label>{{ $t('labels.guidance_box') }} ({{specific_vessel_type_guidance.vessel_name}})</label>

                        <vs-textarea
                          type="text"
                          class="w-full mb-0"
                          :name="'specific_guidance_' + specific_vessel_type_guidance.vessel_type_id"
                          maxlength="5000"
                          v-model="specific_vessel_type_guidance.guidance"
                          icon-no-border
                          v-validate="'required'"
                          height="150"
                        />
                        <span
                          class="text-danger text-sm"
                        >{{ errors.first('specific_guidance_'+ specific_vessel_type_guidance.vessel_type_id) }}</span>

                        <div
                          class="vx-row mt-2 ml-0"
                          v-if="specific_vessel_type_guidance.children.length != 0"
                        >
                          <div class="w-full mt-6 sm: mb-2 md:mb-0 flex">
                            <label>{{ $t('labels.subtypes') }} ({{specific_vessel_type_guidance.vessel_name}})</label>
                            <vs-checkbox
                              @click="checkAllSubtype($event,index)"
                              v-model="specific_vessel_type_guidance.checkall"
                              class="sm: mb-2 md:mb-0 pr-6 mt-1 ml-4"
                            >{{ $t('labels.all')}}</vs-checkbox>
                          </div>
                          <div
                            v-for="(vessel_sub_type, vsbindex) in specific_vessel_type_guidance.children"
                            :key="vsbindex"
                            class="vx-col sm: w-full md:w-1/4 pr-6 pl-0 flex mb-2 mt-2"
                          >
                            <vs-checkbox
                              v-model="specific_vessel_type_guidance.sub_types"
                              :name="'sub_type_' + specific_vessel_type_guidance.vessel_type_id"
                              :vs-value="vessel_sub_type.id"
                              :id="'sub_type'+vessel_sub_type.id"
                              @click="checkSubtype($event,index)"
                              v-validate="'required'"
                            >{{vessel_sub_type.name}}</vs-checkbox>
                          </div>
                          <span
                            class="text-danger text-sm pl-2 sample"
                          >{{ errors.first('sub_type_' + specific_vessel_type_guidance.vessel_type_id) }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Flags -->
                  <div class="vx-row mt-6">
                    <div class="vx-col w-full px-4">
                      <label>{{ $t('labels.flags')}}</label>
                      <ul class="centerx flex mt-4">
                        <li class="mr-4">
                          <vs-radio v-model="flag" vs-value="AF">{{ $t('labels.all') }}</vs-radio>
                        </li>
                        <li class="mr-4 ml-3">
                          <vs-radio v-model="flag" vs-value="SF">{{ $t('labels.specific_to_flag') }}</vs-radio>
                        </li>
                      </ul>
                    </div>
                    <div class="vx-col w-full px-4 mt-3" v-if="flag === 'SF'">
                      <v-select
                        multiple
                        v-model="flags"
                        :options="countries"
                        :reduce="countries => countries.id"
                        label="name"
                        name="flag"
                        v-validate="'required'"
                        :closeOnSelect="false"
                      />
                      <span class="text-danger text-sm">{{ errors.first('flag') }}</span>
                    </div>
                  </div>
                  <!-- Guidance Box -->
                  <div class="vx-row w-full mx-0 mt-6" v-if="flag === 'SF'">
                    <div class="vx-col sm: w-full pl-0 type pr-0">
                      <label>{{ $t('labels.guidance_box')}}</label>
                      <vs-textarea
                        type="text"
                        class="w-full mb-0"
                        name="flag_guidance"
                        maxlength="5000"
                        v-model="flag_guidance"
                        icon-no-border
                        v-validate="'required'"
                        height="150"
                      />
                      <span class="text-danger text-sm">{{ errors.first('flag_guidance') }}</span>
                    </div>
                  </div>
                </vs-tab>
                <vs-tab :label="$t('labels.owners')" class="questions">
                  <!-- All Clients -->
                  <div class="vx-row">
                    <div class="vx-col w-full px-4">
                      <label>{{ $t('labels.owners')}}</label>
                      <ul class="centerx flex mt-4">
                        <li class="mr-4">
                          <vs-radio v-model="client" vs-value="O">{{ $t('labels.all') }}</vs-radio>
                        </li>
                        <li class="mr-4 ml-3">
                          <vs-radio
                            v-model="client"
                            vs-value="SO"
                          >{{ $t('labels.specific_to_owners') }}</vs-radio>
                        </li>
                      </ul>
                    </div>
                    <div class="vx-col w-full px-4 mt-3" v-if="client !== 'O'">
                      <v-select
                        multiple
                        v-model="users"
                        name="owner"
                        :reduce="options => options.id"
                        :options="options"
                        label="name"
                        v-validate="'required'"
                        :closeOnSelect="false"
                      />
                      <span class="text-danger text-sm">{{ errors.first('owner') }}</span>
                    </div>
                  </div>
                </vs-tab>
                <vs-tab :label="$t('labels.services')" class="questions">
                  <!-- Services -->
                  <div class="vx-row">
                    <div class="vx-col w-full px-4">
                      <label>{{ $t('labels.services')}}</label>
                      <ul class="centerx flex mt-4">
                        <li class="mr-4">
                          <vs-radio v-model="services" vs-value="ASR">{{ $t('labels.all') }}</vs-radio>
                        </li>
                        <li class="mr-4 ml-3">
                          <vs-radio
                            v-model="services"
                            vs-value="SSR"
                          >{{ $t('labels.specific_to_service') }}</vs-radio>
                        </li>
                      </ul>
                    </div>
                    <div class="vx-col w-full px-4 mt-3" v-if="services !== 'ASR'">
                      <v-select
                        multiple
                        v-model="service"
                        :options="services_drop"
                        :reduce="services_drop => services_drop.id"
                        label="name"
                        name="service"
                        v-validate="'required'"
                        :closeOnSelect="false"
                      />
                      <span class="text-danger text-sm">{{ errors.first('service') }}</span>
                    </div>
                  </div>
                </vs-tab>
                <vs-tab :label="$t('labels.designations')" class="questions">
                  <!-- Designations -->
                  <div class="vx-row">
                    <div class="vx-col w-full px-4">
                      <label>{{ $t('labels.designations')}}</label>
                      <ul class="centerx flex mt-4">
                        <li class="mr-4">
                          <vs-radio v-model="designations" vs-value="AD">{{ $t('labels.all') }}</vs-radio>
                        </li>
                        <li class="mr-4 ml-3">
                          <vs-radio
                            v-model="designations"
                            vs-value="SD"
                          >{{ $t('labels.specific_to_designation') }}</vs-radio>
                        </li>
                      </ul>
                    </div>
                    <div class="vx-col w-full px-4 mt-3" v-if="designations === 'SD'">
                      <v-select
                        multiple
                        v-model="designation"
                        :options="designations_drop"
                        :reduce="designations_drop => designations_drop.id"
                        label="name"
                        name="select_designations"
                        v-validate="'required'"
                        :closeOnSelect="false"
                      />
                      <span class="text-danger text-sm">{{ errors.first('select_designations') }}</span>
                    </div>
                  </div>
                </vs-tab>
                <vs-tab :label="$t('labels.regulation_reference')">
                  <!-- Regulation Reference -->
                  <div class="vx-row w-full mx-0 mb-6">
                    <div class="vx-col sm: w-full pl-0 pr-0">
                      <label>{{ $t('labels.regulation_reference')}}</label>
                      <vs-textarea
                        type="text"
                        class="w-full mb-0 mt-1"
                        name="regulation_reference"
                        maxlength="5000"
                        v-model="regulation_ref"
                        icon-no-border
                        height="150"
                      />
                    </div>
                  </div>
                </vs-tab>
              </vs-tabs>
            </div>
            <!-- Buttons -->
            <div class="mt-2 flex justify-center">
              <vs-button
                class="md:w-auto md:mr-3 md:mt-0 md:mb-0 login-btn"
                color="dark"
                type="filled"
                :disabled="button_loading"
                id="question-add-edit"
                button="submit"
              >{{ editRoute ? $t('labels.update_question') : $t('labels.add_question') }}</vs-button>
            </div>
          </div>
        </vs-row>
      </form>
    </vx-card>
  </div>
</template>
<script>
import vSelect from "vue-select";
import VueUploadMultipleImage from "vue-upload-multiple-image";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";

export default {
  data() {
    return {
      // test
      checkall: null,
      testing: true,
      vessel_type_guidance: null,
      tab: 0,
      question_number: null,
      question_name: null,
      selected_subtype: null,
      child_id: null,
      childSection: [],
      section: null,
      sections: [],
      number: null,
      numbers: [],
      sub_section: 1,
      users: [],
      vesselSubTypes: [],
      subtype_id: null,
      vesselTypes: [],
      parent_type: null,
      vesselParentTypes: [],
      service: [],
      services_drop: [],
      services: "ASR",
      countries: [],
      type: [],
      options: [],
      usertype: "",
      client: "O",
      alltype: "A",
      importance: "H",
      flag: "AF",
      flags: [],
      designations: "AD",
      designation: [],
      designations_drop: [],
      start_date: null,
      end_date: null,
      is_active: true,
      fromDate: null,
      toDate: null,
      configFromdateTimePicker: {
        minDate: null,
        maxDate: null,
        altFormat: "Y/m/d",
        allowInput:true,
        dateFormat: "Y/m/d"
      },
      configTodateTimePicker: {
        minDate: null,
        allowInput:true,
        dateFormat: "Y/m/d"
      },
      vessel_type_guidance_array: [],
      regulation_ref: "",
      images: [],
      availableImages: [],
      receipt_images: [],
      new_receipt_images: [],
      remove_data: {},
      flag_guidance: null
    };
  },
  components: {
    VueUploadMultipleImage,
    flatPickr,
    "v-select": vSelect
  },
  computed: {
    editRoute() {
      if (this.$route.params.id) {
        return this.$route.params.id;
      } else {
        return false;
      }
    }
  },
  watch: {
    section() {
      this.child_id = null;
      this.getSubSections();
    },
    type(val) {
      let new_array = [];
      for (var i = 0; i < val.length; i++) {
        var vessel_type_id = val[i].id;
        var vessel_name = val[i].name;
        var children = val[i].children;
        let index = this.vessel_type_guidance_array.findIndex(
          item => item.vessel_type_id === vessel_type_id
        );
        new_array.push({
          checkall:
            index !== -1
              ? this.vessel_type_guidance_array[index].checkall
              : false,
          vessel_type_id: vessel_type_id,
          vessel_name: vessel_name,
          children: children,
          guidance:
            index !== -1 ? this.vessel_type_guidance_array[index].guidance : "",
          sub_types:
            index !== -1 ? this.vessel_type_guidance_array[index].sub_types : []
        });
      }

      this.vessel_type_guidance_array = new_array;
    }
  },
  async mounted() {
    this.setValidationMessage();
    this.getSections();
    this.getAllOwner();
    await this.getVesselTypes();
    this.getServices();
    this.getCountries();
    this.getDesignations();
    if (this.editRoute) {
      this.getQuestions();
    }
    let imgUpload = document.getElementById("image-upload");
    if (imgUpload) {
      imgUpload.removeAttribute("multiple");
    }
  },
  methods: {
    datachange() {},
    checkAllSubtype(e, index) {
      let data = this.vessel_type_guidance_array[index];
      let st = [];
      if (!data.checkall) {
        data.children.forEach(child => {
          st.push(child.id);
        });
      } else {
        st = [];
      }
      data.sub_types = st;
      this.vessel_type_guidance_array[index] = data;
    },
    checkSubtype(e, index) {
      setTimeout(() => {
        let data = this.vessel_type_guidance_array[index];
        if (data.sub_types.length != data.children.length) {
          data.checkall = false;
        } else {
          data.checkall = true;
        }
        this.vessel_type_guidance_array[index] = data;
      }, 200);
    },
    async checkValidation() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.createUpdateQuestion();
        }
      });
    },

    // API Integration for section listing
    async getSections() {
      let input = {
        only_parents: true,
        with_children: true
      };
      let response = await this.getHTTPPostResponse("/sections/list", input);
      if (response) {
        let sections = response.data.sections;
        let filteredSection = [];
        for (var i = 0; i < sections.length; i++) {
          let obj = { id: sections[i].id, name: sections[i].name };
          filteredSection.push(obj);
        }
        this.sections = filteredSection;
      }
    },
    // API Integration for subsection listing
    async getSubSections() {
      let input = {
        parent_id: this.section
      };
      let response = await this.getHTTPPostResponse("/sections/list", input);
      if (response) {
        let sections = response.data.sections;
        let filteredSections = [];
        for (var i = 0; i < sections.length; i++) {
          let obj = { id: sections[i].id, name: sections[i].name };
          filteredSections.push(obj);
        }
        this.childSection = filteredSections;
        /* this.child_id = null; */
      }
    },
    // API Integration gor owners listing
    async getAllOwner(
      input = {
        type: "CL",
        sub_type: "OW"
      }
    ) {
      let response = await this.getHTTPPostResponse("/users", input);
      if (response) {
        let users = response.data.users;
        let filteredOwners = [];
        for (var i = 0; i < users.length; i++) {
          var user = users[i];
          filteredOwners.push({ id: user.id, name: user.name });

          if (user.children.length) {
            for (var j = 0; j < user.children.length; j++) {
              var child = user.children[j];

              filteredOwners.push({
                id: child.id,
                name: "----- " + child.name
              });
            }
          }
        }
        this.options = filteredOwners;
        return response.data.users;
      }
    },

    // API Integration for vessel types
    async getVesselTypes(
      input = {
        only_parents: true,
        with_children: true
      }
    ) {
      let response = await this.getHTTPPostResponse("/vesselType/list", input);
      if (response) {
        let types = response.data.vesselTypes;

        this.vesselTypes = types;
        return response;
      }
    },
    // API Integration for services
    async getServices() {
      let input = {
        name: this.service
      };
      let response = await this.getHTTPPostResponse("/services/list", input);
      if (response) {
        let service_req = response.data.services;
        let filteredServices = [];
        for (var i = 0; i < service_req.length; i++) {
          let obj = { id: service_req[i].id, name: service_req[i].name };
          filteredServices.push(obj);
        }
        this.services_drop = filteredServices;
      }
    },
    // API Integration for Flags
    async getCountries() {
      let input = {
        name: this.flag
      };
      let response = await this.getHTTPPostResponse("/country/list", input);
      if (response) {
        let country_req = response.data.countries;
        let filteredFlags = [];
        for (var i = 0; i < country_req.length; i++) {
          let obj = { id: country_req[i].id, name: country_req[i].name };
          filteredFlags.push(obj);
        }
        this.countries = filteredFlags;
      }
    },
    // API Integration for Designations
    async getDesignations() {
      let input = {
        name: this.designation
      };
      let response = await this.getHTTPPostResponse(
        "/designations/list",
        input
      );
      if (response) {
        let designation_req = response.data.designations;
        let filteredDesignations = [];
        for (var i = 0; i < designation_req.length; i++) {
          let obj = {
            id: designation_req[i].id,
            name: designation_req[i].name
          };
          filteredDesignations.push(obj);
        }
        this.designations_drop = filteredDesignations;
      }
    },
    onFromChange(selectedDates, dateStr) {
      this.$set(this.configTodateTimePicker, "minDate", dateStr);
    },
    onToChange(selectedDates, dateStr) {
      this.$set(this.configFromdateTimePicker, "maxDate", dateStr);
    },
    // API Integration for Create Update Question
    async createUpdateQuestion() {
      var images = this.$refs["multiple_image_"].images;
      var images_url = images.map(image => {
        return image.s3_url;
      });
      let input = {
        question: this.question_name,
        section_id: this.section,
        sub_section_id: this.child_id,
        question_number: this.number,
        importance: this.importance,
        images: images_url,
        is_active: this.is_active,
        regulation_reference: this.regulation_ref,
        active_from: this.fromDate ? moment(this.fromDate).format("Y-MM-DD") : null,
        active_to: this.toDate ? moment(this.toDate).format("Y-MM-DD") : null
      };
      if (this.alltype == "A") {
        input.vessel_type_guidance = this.vessel_type_guidance;
      } else {
        input.vessel_type_guidances = this.vessel_type_guidance_array;
      }
      if (this.flag == "SF") {
        input.flag_guidance = this.flag_guidance;
      }
      if (this.client == "O") {
        input.all_clients = true;
      } else {
        input.all_clients = false;
        input.client_ids = this.users;
      }
      if (this.alltype == "A") {
        input.all_vessel_types = true;
      } else {
        input.all_vessel_types = false;
        input.vessel_type_ids = this.type;
      }
      if (this.services == "ASR") {
        input.all_services = true;
      } else {
        input.all_services = false;
        input.service_ids = this.service;
      }
      if (this.flag == "AF") {
        input.all_flags = true;
      } else {
        input.all_flags = false;
        input.flag_ids = this.flags;
      }
      if (this.designations == "AD") {
        input.all_designations = true;
      } else {
        input.all_designations = false;
        input.designation_ids = this.designation;
      }
      let url = this.editRoute
        ? "/questions/update/" + this.editRoute
        : "/questions/create";
      let response = await this.getHTTPPostResponse(
        url,
        input,
        "#question-add-edit",
        true
      );
      if (response) {
        this.$router.push({ name: "Questions" });
      }
    },

    // API Integration for getData
    async getQuestions() {
      let response = await this.getHTTPGetResponse(
        "/questions/get/" + this.editRoute
      );

      if (response) {
        let data = response.data;
        let questions = data.question;
        this.question_name = questions.question;
        this.section = questions.section_id;
        setTimeout(() => {
          this.child_id = questions.sub_section_id;
        }, 1000);
        this.number = questions.question_number;
        this.importance = questions.importance;
        this.is_active = questions.is_active;

        let vessel_types = questions.vessel_types;

        vessel_types.forEach(vessel_type => {
          var vesselType = this.vesselTypes.filter(
            v => v.id === vessel_type.id
          )[0];

          vessel_type.id = vesselType.id;
          vessel_type.name = vesselType.name;
          vessel_type.children = vesselType.children;

          this.type.push(vessel_type);
        });

        setTimeout(() => {
          let vessel_type_guidance_data = [];
          vessel_types.forEach(vessel_type => {
            var sub_types = vessel_type.question_vessel_type.vessel_sub_types;

            sub_types = sub_types.map(sub_type => {
              return sub_type.id;
            });

            vessel_type_guidance_data.push({
              vessel_type_id: vessel_type.id,
              vessel_name: vessel_type.name,
              children: vessel_type.children,
              guidance: vessel_type.question_vessel_type.guidance,
              sub_types: sub_types,
              checkall:
                vessel_type.children.length == sub_types.length ? true : false
            });
          });

          this.vessel_type_guidance_array = vessel_type_guidance_data;
        }, 100);

        this.regulation_ref = questions.regulation_reference;
        this.fromDate = moment(questions.active_from).format("yyyy/MM/DD");
        this.toDate = moment(questions.active_to).format("yyyy/MM/DD");
        // Display stored images
        if (questions.images != null && questions.images.length != 0) {
          var images = [];
          questions.images.forEach(element => {
            if (element != null) {
              images.push({
                path: element,
                s3_url: element
              });
            }
          });
          this.images = images;
        } else {
          this.images = [];
        }
        this.client = questions.all_clients == false ? "SO" : "O";
        let cluser = questions.clients;
        cluser.forEach(element => {
          this.users.push(element.id);
        });
        this.alltype = questions.all_vessel_types == false ? "ST" : "A";
        if (questions.all_vessel_types == true) {
          this.vessel_type_guidance = questions.vessel_type_guidance;
        }
        this.services = questions.all_services == false ? "SSR" : "ASR";
        let services = questions.services;
        services.forEach(element => {
          this.service.push(element.id);
        });
        if (questions.all_flags == false) {
          this.flag_guidance = questions.flag_guidance;
        }
        this.flag = questions.all_flags == false ? "SF" : "AF";
        let flags = questions.flags;
        flags.forEach(element => {
          this.flags.push(element.id);
        });
        this.designations = questions.all_designations == false ? "SD" : "AD";
        let designations = questions.designations;
        designations.forEach(element => {
          this.designation.push(element.id);
        });
      }
    },
    // API Integration for Guidance Images
    dataChange(data) {},

    fileUpload(event) {
      let that = this;
      var input = event.target;

      if (input.files && input.files[0]) {
        if (
          input.files[0].type !== "image/jpeg" &&
          input.files[0].type !== "image/jpg" &&
          input.files[0].type !== "image/png"
        ) {
          alert("Invalid file type");
          return false;
        }
        var reader = new FileReader();
        reader.onload = e => {
          var image = new Image();
          image.src = e.target.result;
          image.onload = function() {
            that.filename = input.files[0].name;
            that.images = input.files[0];
          };
          this.images = e.target.result;
        };
        reader.readAsDataURL(input.files[0]);
      }
    },

    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    removeImage() {
      let input = {
        url: this.url
      };
      this.axios
        .post("s3/remove", input)
        .then(response => {
          // show notification only
          // if new image is deleted.
          this.remove_data.done();
          if (!this.remove_data.edit) {
            this.$vs.notify({
              title: "Success.",
              text: response.data.message,
              color: "success",
              position: "top-right"
            });
          }
          return "tttttt";
        })
        .catch(e => {
          this.images.splice(this.remove_data.index, 1);
          this.remove_data.done();
          this.showError(e);
        });
    },
    uploadImageSuccess(formData, index, fileList) {
      let fileImage = this.dataURLtoFile(
        fileList[index].path,
        fileList[index].name
      );
      let flag = 1;
      if (
        fileImage.type === "image/png" ||
        fileImage.type === "image/jpeg" ||
        fileImage.type === "image/jpg"
      ) {
        flag = 1;
      } else {
        alert("Please upload image with extension .png ,.jpg, .jpeg");
        flag = 0;
        this.images.splice(index, 1);
        return false;
      }
      if (fileImage.size > 10000000) {
        alert("Please upload under 10mb!");
        this.images.splice(index, 1);
        return false;
      } else {
        var input = new FormData();
        input.append("directory", "listing");
        input.append("attachment", fileImage);
        this.axios
          .post("s3/upload", input)
          .then(response => {
            let data = response.data.data;

            fileList[index].s3_url = data.url;
            this.$vs.notify({
              title: "Success.",
              text: response.data.message,
              color: "success",
              position: "top-right"
            });
          })
          .catch(e => {
            this.showError(e);
          });
      }
    },
    beforeRemove(index, done, fileList) {
      this.url = fileList[index].s3_url;
      this.index = index;
      this.remove_data = {
        index: index,
        done: done
      };
      this.$vs.dialog({
        type: "confirm",
        color: "rgba(var(--vs-primary),1)",
        title: this.$t("labels.delete"),
        acceptText: this.$t("labels.yes"),
        cancelText: this.$t("labels.no"),
        text: this.$t("strings.delete_confirm"),
        accept: this.removeImage
      });
    },
    goBack() {
      history.back();
    }
  }
};
</script>
<style scoped>
button.login-btn {
  background: rgba(var(--vs-primary), 1) !important;
}
.vs-button-primary.vs-button-filled:hover {
  box-shadow: 0 8px 25px -8px rgba(var(--vs-primary), 1);
}
.bold-fields {
  font-size: 17px;
  font-weight: 600;
  color: #626262;
}
.font {
  font-size: 13px;
}
.font-bold {
  font-size: 18px;
  font-weight: 600;
  color: #626262;
}
</style>
